module.exports = __webpack_public_path__ + "img/max-file-repeat--csv.c9af52c2.svg";